import './header-info.scss';

import { Tooltip } from 'antd';

import InfoCard from '@/components/Shared/InfoCard';
import { EOrganizationTypesCode } from '@/components/Shared/constants/dicts-codes';
import EditIcon from '@/media/icons/edit.svg?react';
import WarningIcon from '@/media/icons/warning-fill.svg?react';
import PhoneIcon from '@/media/svg/phone.svg?react';
import { validateNumberInputValue } from '@/services';
import { formatPhoneNumber } from '@/services/formatter';
import { getUserFullName } from '@/services/helpers/strings';
import { useAppSelector } from '@/store';

interface IProps {
  openEditModal?: () => void;
  setHistoryModal: (value: boolean) => void;
}

const HeaderInfo: React.FC<IProps> = ({ openEditModal, setHistoryModal }) => {
  const { loan, orderApp, clientInfo, leasingOrder } = useAppSelector(
    (state) => state.newOrder
  );

  const shouldShowErrorPhone =
    !clientInfo?.isClientPhoneNumberVerified &&
    (orderApp?.status === 'draft' ||
      orderApp?.status === 'waiting_bank_response');

  const isIEOrOtherCompanyType =
    Number(orderApp?.personalInfo?.companyType) === EOrganizationTypesCode.IP ||
    Number(orderApp?.personalInfo?.companyType) ===
      EOrganizationTypesCode.Other;
  const isHasLeasing =
    orderApp?.sentTo === 'leasing' || orderApp?.sentTo === 'banks_leasing';
  const isIndividualEntrepreneur =
    leasingOrder?.isClientIpOwner && isHasLeasing && isIEOrOtherCompanyType;

  return (
    <div className="request-header-info">
      <InfoCard
        title={getUserFullName(clientInfo, {
          defaultValues: {
            firstName: '-',
            lastName: '-',
            middleName: '-'
          }
        })}
        icon={
          !!openEditModal && <EditIcon className="request-header-info__icon" />
        }
        onClick={openEditModal}
        subtitle={
          <>
            ИИН: {clientInfo.iin}
            {isIndividualEntrepreneur && (
              <span className="request-header-info__individual-entrepreneur">
                (Оформитель ИП)
              </span>
            )}
          </>
        }
      />
      <InfoCard
        title={formatPhoneNumber(clientInfo.telNum)}
        subtitle="Номер телефона"
        isPhoneNumber
        icon={
          shouldShowErrorPhone ? (
            <Tooltip title="Предоставленный клиентом номер не совпал с указанным в сервисе БМГ по ИИНу и возможны отказы по некоторым банкам">
              <WarningIcon className="request-header-info__icon request-header-info__icon--error" />
            </Tooltip>
          ) : (
            <PhoneIcon className="request-header-info__icon" />
          )
        }
      />
      {orderApp?.status !== 'draft' && (
        <InfoCard
          title={loan.auto || 'Нет данных'}
          subtitle={`${validateNumberInputValue(loan.amount, 9, true)} ₸`}
        />
      )}
      <InfoCard
        title={`ID #${clientInfo.id}`}
        subtitle={
          <span
            className="request-header-info__history-text"
            onClick={() => setHistoryModal(true)}
          >
            История изменений
          </span>
        }
      />
    </div>
  );
};

export default HeaderInfo;
